import { Building2, EyeOff, LucideIcon, Share2, User } from "lucide-react";
import { DashboardIdentityKind } from "./dashboardIdentity";

/**
 * One colour per audience (LAR-661), shared by the pill, the edit banner and the name-clash
 * warning: grey for personal, the brand colour for the organisation's, amber for a draft and
 * violet for a dashboard inherited from the parent organisation.
 */
export const IDENTITY_STYLE: Record<DashboardIdentityKind, string> = {
  personal: "border-border bg-muted text-foreground",
  "organisation-published": "border-primary/30 bg-primary/10 text-primary",
  // Amber carries the meaning in the border, tint and icon; the text stays the foreground colour,
  // because warning-foreground is near-black in dark mode too.
  "organisation-draft": "border-warning/50 bg-warning/15 text-foreground",
  "parent-readonly":
    "border-dashboard-inherited/30 bg-dashboard-inherited/10 text-dashboard-inherited",
};

export const IDENTITY_ICON: Record<DashboardIdentityKind, LucideIcon> = {
  personal: User,
  "organisation-published": Building2,
  "organisation-draft": EyeOff,
  "parent-readonly": Share2,
};
